export default __webpack_public_path__ + "static/media/base-report15.baed049d.png";